import actions from './actions.js'
import getters from './getters.js'
import mutations from './mutations.js'

const state = {
  numMerchants: 0,
  currentMerchant: null,
  merchants: [],
  merchantLoading: false,
  numCustomers: 0,
  currentCustomer: {},
  customers: [],
  customerLoading: false,
  recentPaymentLoading: false,
  numAccounts: 0,
  accounts: [],
  accountLoading: false,
  transactionReportURL: '',
  pageTitle: [],
  csvData: {},
  isRefreshComplete: false,
  startupLoadError: null,
  currentAccount: {},
  locations: [],
  currentLocation: {},
  selectedLocation: {},
  currentMerchantAccount: {},
  group: null,
  users: [],
  oauthLinks: {},
  accountTags: [],
  failedActions: [],
  receiptModalOpen: false,
  currentPayment: null,
  accountPromises: [],
  accountPromisesLoading: false,
  merchantAccounts: [],
  merchantAccountsLoading: false,
  binInfo: {},
  binInfoLoading: false,
  roleLoading: false,
  role: {},
  dashboardDateRange: {},
  isSideNavOpen: true,
  isReportsFlyoutOpen: false,
  starredReports: [],
  uiPreferences: {},
  aiBatchConfigs: [],
  aiBatchConfigsCount: 0,
  aiBatchConfigsLoading: false,
  aiCallerAgents: [],
  aiCallerAgentsLoading: false,
  aiCallerBatches: [],
  aiCallerBatchesCount: 0,
  aiCallerBatchesLoading: false
}

export default {
  state: () => state,
  mutations,
  actions,
  getters
}
